export const transactionTypes = {
    CREDITOR_ACCOUNT_DEPOSIT: "Vklad na účet",
    ACCOUNT_WITHDRAWAL: "Výber z účtu",
    INVESTMENT_OFFER: "Investičná ponuka",
    CANCEL_INVESTMENT_OFFER: "Zrušenie investičnej ponuky",
    LOAN_DRAWING: "Poskytnutie pôžičky",
    LOAN_WITHDRAWAL: "Čerpanie pôžičky na bankový účet žiadateľa",
    PROVISION_FOR_LOAN_WITHDRAWAL: "Poplatok za poskytnutie pôžičky",
    DEBTOR_ACCOUNT_DEPOSIT: "Vklad na účet",
    LOAN_INSTALLMENT: "Splátka pôžičky",
    LOAN_INSTALLMENT_PRINCIPAL_DEBTOR: "Splátka pôžičky - istina",
    LOAN_INSTALLMENT_INTEREST_DEBTOR: "Splátka pôžičky - úrok",
    LOAN_INSTALLMENT_PRINCIPAL: "Splátka pôžičky - istina",
    LOAN_INSTALLMENT_INTEREST: "Splátka pôžičky - úrok",
    LOAN_INSTALLMENT_INSURANCE: "Splátka pôžičky - poistenie",
    LOAN_INSTALLMENT_PENALTY_FEE: "Splátka pôžičky - sankčný poplatok",
    LOAN_INSTALLMENT_MARGIN: "Splátka pôžičky - marža",
    LOAN_EARLY_REPAYMENT_FEE: "Poplatok za predčasné splatenie pôžičky",
    INVESTMENT_EARLY_TERMINATION_FEE: "Poplatok za predčasné ukončenie investície",
    FEE_WITHDRAWAL: "Výber poplatkov",
    INSURANCE_WITHDRAWAL: "Výber poistenie",
    LOAN_DISPOSAL_FROM_EXECUTOR: "Odkup pohľadávky od Inkasárne",
    LOAN_DISPOSAL_TO_INVESTOR: "Odkup pohľadávky",
    SETTLEMENT_DEPOSIT: "Vysporiadavacia transakcia",
    STORNO_PENALTY_FEE: "Storno sankčného poplatku",
    RETURN_OVERPAY: "Vrátenie preplatku",
    INSTALLMENT_SHIFT_FEE: "Poplatok za posun splátky",
    ALLOCATION_TRANSFER_BUYOUT: "Kúpa na sekundárnom trhu",
    ALLOCATION_TRANSFER_SELL: "Predaj na sekundárnom trhu",
    ALLOCATION_TRANSFER_SELL_FEE: "Poplatok za prevod na sekundárnom trhu",
    TRUSTPAY_FEE: "Poplatok za spracovanie platby kartou",
    BANK_TRANSACTION_FEE: "Transakčná daň",
    CREDITOR_BONUS_INTEREST: "Bonus investora"
};

export const creditorTransactionTypes = [
    'CREDITOR_ACCOUNT_DEPOSIT',
    'ACCOUNT_WITHDRAWAL',
    'LOAN_DRAWING',
    'LOAN_INSTALLMENT_PRINCIPAL',
    'LOAN_INSTALLMENT_INTEREST',
    'INVESTMENT_EARLY_TERMINATION_FEE',
    'LOAN_DISPOSAL',
    'SETTLEMENT_DEPOSIT',
    'ALLOCATION_TRANSFER_BUYOUT',
    'ALLOCATION_TRANSFER_SELL',
    'ALLOCATION_TRANSFER_SELL_FEE'
]

export const debtorTransactionTypes = [
    'ACCOUNT_WITHDRAWAL',
    'LOAN_DRAWING',
    'LOAN_WITHDRAWAL',
    'PROVISION_FOR_LOAN_WITHDRAWAL',
    'DEBTOR_ACCOUNT_DEPOSIT',
    'LOAN_INSTALLMENT',
    'LOAN_INSTALLMENT_PRINCIPAL_DEBTOR',
    'LOAN_INSTALLMENT_INTEREST_DEBTOR',
    'LOAN_EARLY_REPAYMENT_FEE',
    'SETTLEMENT_DEPOSIT'
]



// WEBPACK FOOTER //
// ./src/common/enums/transactionTypes.js